import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../core/services/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  alert: any = { show: false, message: '', type: '' };

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {
    this.alertService.alertState$.subscribe((alert) => {
      this.alert = alert;
      if (alert?.show) {
        setTimeout(() => this.alertService.hideAlert(), 5000);
      }
    });
  }

  onAlertClosed(): void {
    this.alertService.hideAlert();
  }
}
